<script setup>
import { computed } from "vue";
import { ChevronLeft, ChevronRight } from "@lucide/vue";
const props = defineProps({
  page: { type: Number, default: 1 },
  total: { type: Number, default: 0 },
  perPage: { type: Number, default: 12 },
});
const emit = defineEmits(["update:page"]);
const pages = computed(() =>
  Math.max(1, Math.ceil(props.total / props.perPage)),
);
const visible = computed(() => {
  const start = Math.max(1, Math.min(props.page - 2, pages.value - 4));
  return Array.from({ length: Math.min(5, pages.value) }, (_, i) => start + i);
});
</script>
<template>
  <div
    v-if="total > perPage"
    class="flex items-center justify-between border-t border-slate-200 px-5 py-4"
  >
    <span class="text-xs font-medium text-slate-500">{{ total }} kayit</span>
    <div class="flex items-center gap-1">
      <button
        class="icon-btn size-9"
        :disabled="page <= 1"
        @click="emit('update:page', page - 1)"
      >
        <ChevronLeft class="size-4" /></button
      ><button
        v-for="item in visible"
        :key="item"
        :class="[
          'size-9 rounded-md text-xs font-bold',
          item === page
            ? 'bg-brand-600 text-white'
            : 'text-slate-600 hover:bg-slate-100',
        ]"
        @click="emit('update:page', item)"
      >
        {{ item }}</button
      ><button
        class="icon-btn size-9"
        :disabled="page >= pages"
        @click="emit('update:page', page + 1)"
      >
        <ChevronRight class="size-4" />
      </button>
    </div>
  </div>
</template>
